import { Calendar, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

export const CTASection = () => {
  return (
    <section
      className="py-20 lg:py-28 bg-[#0A0A0A] relative overflow-hidden"
      data-testid="cta-section"
    >
      {/* Subtle gradient background effect */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#c1ff72]/5 via-transparent to-transparent pointer-events-none" />
      
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center">
          {/* Headline */}
          <h2 className="font-['Bebas_Neue'] text-4xl sm:text-5xl md:text-6xl lg:text-7xl uppercase tracking-tight text-white mb-6">
            BEREIT FÜR DEIN{" "}
            <span className="text-[#c1ff72]">NÄCHSTES LEVEL</span>?
          </h2>
          
          {/* Subtext */}
          <p className="text-[#A1A1AA] text-lg md:text-xl max-w-2xl mx-auto mb-10 leading-relaxed">
            Starte jetzt dein individuelles Fußballtraining und verbessere deine Technik gezielt.
          </p>
          
          {/* CTA Button - Larger than standard */}
          <Link to="/buchen">
            <Button
              className="bg-[#c1ff72] hover:bg-[#d4ff9a] text-[#0A0A0A] font-bold px-10 sm:px-14 py-7 sm:py-8 rounded-none text-lg sm:text-xl transition-all duration-300 hover:shadow-[0_0_50px_rgba(193,255,114,0.5)] hover:scale-105 group"
              data-testid="cta-book-button"
            >
              <Calendar className="w-6 h-6 mr-3 group-hover:animate-pulse" />
              JETZT ONLINE BUCHEN
              <ChevronRight className="w-6 h-6 ml-2 group-hover:translate-x-1 transition-transform" />
            </Button>
          </Link>
          
          {/* Trust indicator */}
          <p className="mt-8 text-[#71717A] text-sm">
            Schnelle Antwort • Flexible Termine • Unverbindliche Anfrage
          </p>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
